import { render, staticRenderFns } from "./DepartManagerHisList.vue?vue&type=template&id=4e4dfbb6&scoped=true"
import script from "./DepartManagerHisList.vue?vue&type=script&lang=js"
export * from "./DepartManagerHisList.vue?vue&type=script&lang=js"
import style0 from "./DepartManagerHisList.vue?vue&type=style&index=0&id=4e4dfbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4dfbb6",
  null
  
)

export default component.exports